import React from 'react'
import './index.scss'

interface NakedButtonProps {
    onClick: () => void
    children: any
}

const NakedButton = (props: NakedButtonProps) => {
    const { onClick, children } = props

    return (
        <div className="naked-button-component" data-testid="naked-button-component">
            <button className="naked-color-set primary" onClick={onClick}>
                {children}
            </button>
        </div>
    )
}

export default NakedButton
